import * as icons from '@mui/icons-material';
import { Typography, SvgIcon } from '@mui/material';
import { Link as MuiLink } from '@mui/material';
import { useApiUrl, useCustom } from '@refinedev/core';
import { type RefineLayoutThemedTitleProps } from '@refinedev/mui';
import { useMemo } from 'react';
import { useParams } from 'react-router';
import { OrganizationWithAccountsAndMagazines } from '../../types/account.ts';

export const Title: React.FC<RefineLayoutThemedTitleProps> = ({ collapsed, wrapperStyles }) => {
  const { organizationId } = useParams<{ organizationId: string }>();
  const API_URL = useApiUrl();

  const { data: _data } = useCustom<OrganizationWithAccountsAndMagazines>({
    url: `${API_URL}/organization/${organizationId}/dashboard`,
    method: 'get',
    config: {},
    queryOptions: {
      queryKey: ['dashboard'],
      enabled: true,
    },
  });

  const data = useMemo(
    () => (_data?.data ? OrganizationWithAccountsAndMagazines.parse(_data?.data) : undefined),
    [_data?.data],
  );

  if (!data) {
    return null;
  }

  return (
    <MuiLink
      underline="none"
      href={`/organization/${organizationId}/`}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        ...wrapperStyles,
      }}
    >
      <SvgIcon height="24px" width="24px" color="primary">
        <icons.Domain />
      </SvgIcon>
      {!collapsed && (
        <Typography
          variant="h6"
          fontWeight={700}
          color="text.primary"
          fontSize="inherit"
          textOverflow="ellipsis"
          overflow="hidden"
        >
          {data.name}
        </Typography>
      )}
    </MuiLink>
  );
};
